"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = _interopRequireDefault(require("../shared/utils"));

var _Logger = _interopRequireDefault(require("../shared/Logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var logger = new _Logger["default"]('scout');
/**
 * @class Scout
 */

function Scout() {
  if (!(this instanceof Scout)) return new Scout();
  this.options = {};
  this.plugins = [];
  this.storeHandlers = [];
}
/**
 * 获取一个全新的 store，store 是一个数据接收器，依次调用 storeHandler 时会往上挂数据
 *
 * @memberof Scout.prototype
 * @returns {Object} 返回一个全新的 store
 */


Scout.prototype.getStore = function () {
  var _this = this;

  var store = Object.create(null);
  this.storeHandlers.forEach(function (storeHandler) {
    return storeHandler(store, _this);
  });
  return store;
};
/**
 * 初始化
 *
 * @memberof Scout.prototype
 * @param {Object} options - 配置参数
 * @param {string} options.appKey - 应用名
 * @param {string} options.projectName - 埋点项目名
 * @param {Object} [options.pageNames={}] - 用于 PV 事件，path 对应的 page 字段
 * @param {boolean} [options.trackSinglePage=true] - 是否开启自动上报，默认开启
 * @param {boolean} [options.testMode=false] - 是否是测试模式，测试模式不上报数据，默认false
 */


Scout.prototype.init = function (options) {
  if (!options) throw new TypeError('options is required.');
  if (!_utils["default"].isObject(options)) throw new TypeError('options must be an object.');
  this.options = options;
  this.options.projectName = options.projectName || 'qpark_test';
  this.options.pageNames = options.pageNames || {};
  this.options.trackSinglePage = options.hasOwnProperty('trackSinglePage') ? options.trackSinglePage : true;
  this.options.testMode = !!options.testMode; // 依次调用每个插件的 init()

  this.plugins.forEach(initPlugin, this);
};
/**
 * 添加插件
 *
 * @memberof Scout.prototype
 * @param {Object} plugin - Scout 插件
 * @param {Function} plugin.init - 插件初始化方法，可以返回一个 storeHandler
 * @param {string} plugin.name - 插件名称
 */


Scout.prototype.use = function (plugin) {
  if (!_utils["default"].isObject(plugin)) throw new TypeError('plugin must be an object.');
  if (!plugin.init) throw new TypeError('plugin.init is required.');
  if (!plugin.name) throw new TypeError('plugin.name is required.'); // 防止重复添加插件

  if (this.plugins.includes(plugin)) {
    logger.info('%s plugin already exists.', plugin.name);
    return;
  }

  this.plugins.push(plugin);
};
/**
 * 初始化插件
 *
 * @param {Object} plugin - Scout 插件
 * @param {Function} plugin.init - 插件初始化方法，可以返回一个 storeHandler
 * @param {string} plugin.name - 插件名称
 */


function initPlugin(plugin) {
  if (plugin.init && _utils["default"].isFunction(plugin.init)) {
    try {
      var storeHandler = plugin.init(this);
      _utils["default"].isFunction(storeHandler) && this.storeHandlers.push(storeHandler);
    } catch (e) {
      logger.error(e);
    }
  }
}
/**
 * @exports Scout
 */


var _default = Scout;
exports["default"] = _default;